import React, { Component } from 'react';

const AUTO_CONCESSIONS = [
	{
		category: 'Room & Rates',
		items: [
			'Suites offered at group rate',
			'1:40 complimentary guest room on cumulative basis',
			'50% discounted staff rooms',
			'Group rate offered 3 days pre/post event',
			'Hotel to guarantee all late arrivals guest rooms',
			'20% cumulative attrition',
			'Additional room request(s) at group rate',
			'Rooming list due (21) days prior to Main Arrival Dates',
			'No early departure fee'
		]
	},
	{
		category: 'Meeting & Event Space',
		items: [
			'Complimentary event signage outside',
			'Complimentary water service in meeting space',
			'Complimentary meeting planner rooms for period of the meetings',
			'Complimentary meeting room rental with F&B minimum'
		]
	},
	{
		category: 'Technology & Connectivity',
		items: [
			'Complimentary guest room wifi',
			'Complimentary wifi for meeting area',
			'50% discount on dedicated internet',
			'Complimentary wireless internet and phone at reg desks and staff/client offices'
		]
	},
	{
		category: 'Transportation & Parking',
		items: [
			'Round trip SUV airport transfers',
			'Complimentary valet parking passes',
			'Complimentary overnight self-parking'
		]
	},
	{
		category: 'Logistics & Operations',
		items: [
			'Access to loading docks (2) pre program and (2) days post program',
			'Waive shipping/handling fees for all packages arriving for meeting',
			'No charge to rekey offices',
			'No charge to utilize own production company and /or AV equipment'
		]
	},
	{
		category: 'Food & Beverage',
		items: [
			'20% off banquet catering prices',
			'Banquet F&B rebate based on total performance',
			'Complimentary daily snacks and beverages in staff and client offices',
			'Waive bartender and Chef fees with minimum spend of USD $1,000'
		]
	},
	{
		category: 'VIP & Guest Experience',
		items: [
			'Complimentary access to safety deposit boxes',
			'Attendees to receive hotel loyalty points',
			'VIP amenities provided by resort'
		]
	},
	{
		category: 'Fees Waived / Cost Reductions',
		items: [
			'20% off business center',
			'$3 flat rate on guest room deliveries',
			'5% rebate on room revenue for group',
			'Waive resort/destination fee',
			'(1) complimentary 90 minute cocktail welcome reception',
			'Complimentary pre-planning nights'
		]
	}
];

class ConcessionsStep extends Component {
	constructor(props) {
		super(props);
		this.state = {
			inputValue: '',
			selectedAutoItems: new Set(props.data?.selectedAutoItems || [])
		};
	}

	handleKeyDown = (e) => {
		if (e.key === 'Enter') {
			e.preventDefault();
			const trimmed = this.state.inputValue.trim();
			if (trimmed) this.addCustomConcession(trimmed);
		}
	};

	addCustomConcession = (value) => {
		const { data, onChange } = this.props;
		const customConcessions = [...(data.customConcessions || [])];
		if (!customConcessions.includes(value)) {
			customConcessions.push(value);
			onChange('customConcessions', customConcessions);
		}
		this.setState({ inputValue: '' });
	};

	handleAddClick = () => {
		const trimmed = this.state.inputValue.trim();
		if (trimmed) this.addCustomConcession(trimmed);
	};

	removeCustomConcession = (value) => {
		const { data, onChange } = this.props;
		const customConcessions = (data.customConcessions || []).filter(c => c !== value);
		onChange('customConcessions', customConcessions);
	};

	toggleAutoItem = (item) => {
		const { data, onChange } = this.props;
		const newSelected = new Set(this.state.selectedAutoItems);
		
		if (newSelected.has(item)) {
			newSelected.delete(item);
		} else {
			newSelected.add(item);
		}
		
		this.setState({ selectedAutoItems: newSelected });
		onChange('selectedAutoItems', Array.from(newSelected));
	};

	render() {
		const { data } = this.props;
		const { inputValue, selectedAutoItems } = this.state;
		const customConcessions = data.customConcessions || [];

		return (
			<div className="rfp-step-content">
				<h1 className="rfp-step-title">Concessions</h1>

				{/* Custom concession input */}
				<div className="rfp-field-group">
					<label className="rfp-field-label">Please Add Your Preferred Concessions</label>
					<div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
						<div style={{ flex: 1 }}>
							<input
								className="rfp-text-input"
								type="text"
								value={inputValue}
								onChange={(e) => this.setState({ inputValue: e.target.value })}
								onKeyDown={this.handleKeyDown}
								placeholder="eg. wifi for all attendees"
							/>
							<div className="rfp-input-underline" />
						</div>
						<button
							type="button"
							className="rfp-add-concession-btn"
							onClick={this.handleAddClick}
							disabled={!inputValue.trim()}
							style={{
								display: 'inline-flex',
								alignItems: 'center',
								gap: 6,
								padding: '8px 16px',
								background: inputValue.trim() ? '#1a1a1a' : '#d5d5d5',
								color: '#fff',
								border: 'none',
								borderRadius: 20,
								fontSize: 13,
								fontWeight: 600,
								cursor: inputValue.trim() ? 'pointer' : 'not-allowed',
								whiteSpace: 'nowrap',
								flexShrink: 0
							}}
						>
							<i className="las la-plus" />
							Add
						</button>
					</div>
				</div>

				{/* Custom concession tags */}
				{customConcessions.length > 0 && (
					<div className="rfp-concession-tags">
						{customConcessions.map((concession) => (
							<div key={concession} className="rfp-concession-tag rfp-concession-tag-custom">
								{concession}
								<button
									className="rfp-tag-remove"
									onClick={() => this.removeCustomConcession(concession)}
								>
									<i className="las la-times" />
								</button>
							</div>
						))}
					</div>
				)}

				{/* Auto concessions notice */}
				<p className="rfp-concession-notice">
					We will automatically request all selected concessions, if applicable. Click the items below that you would like to prioritize. 
				</p>

				{/* Auto concession categories */}
				{AUTO_CONCESSIONS.map((group) => (
					<div key={group.category} className="rfp-concession-group">
						<div className="rfp-concession-category-label">{group.category}</div>
						<div className="rfp-concession-chips">
							{group.items.map((item) => {
								const isSelected = selectedAutoItems.has(item);
								return (
									<div
										key={item}
										className="rfp-concession-chip"
										onClick={() => this.toggleAutoItem(item)}
										style={{
											cursor: 'pointer',
											background: isSelected ? '#1a1a1a' : '#f5f5f5',
											color: isSelected ? '#fff' : '#333',
											border: `2px solid ${isSelected ? '#1a1a1a' : '#ddd'}`,
											transition: 'all 0.2s ease'
										}}
									>
										{item}
									</div>
								);
							})}
						</div>
					</div>
				))}
			</div>
		);
	}
}

export default ConcessionsStep;
